module.exports = __webpack_public_path__ + "static/media/d5tl6ird1tcwxh8o.1af9e5e3.png";